const translate = {
    common: {
        audit: "Аудит",
        login: "Логін",
        password: "Пароль",
        maskedPassword: "**********",
        date: "Дата",
        today: "Сьогодні",
        yesterday: "Вчора",
        currentWeek: "Поточний тиждень",
        currentMonth: "Поточний місяць",
        currentYear: "Поточний рік",
        period: "Період",
        tier: "Рівень",
        save: "Зберегти",
        operators: "Оператори",
        search: "Пошук",
        online: "Онлайн",
        pause: "Пауза",
        offline: "Офлайн",
        chats: "Чати",
        chat: "Чат",
        channels: "Канали",
        type: "Тип",
        token: "Токен",
        enabled: "Увімкнено",
        name: "Назва",
        settings: "Налаштування",
        permissions: "Дозволи",
        logging: "Логування",
        contact: "Контакт",
        channel: "Канал",
        accounts: "Акаунти",
        contactCommunications: "Засоби зв'язку",
        cancel: "Скасувати",
        delete: "Видалити",
        restore: "Відновити",
        detach: "Відокремити",
        contacts: "Контакти",
        messengers: "Месенджери",
        created: "Створено",
        status: "Статус",
        mailing: "Розсилки",
        start: "Розпочати",
        message: "Повідомлення",
        analytics: "Аналітика",
        synonyms: "Синоніми",
        export: "Експорт",
        import: "Імпорт",
        publish: "Опублікувати",
        changeVersion: "Змінити версію",
        undo: "Скасувати зміни",
        answer: "Відповідь",
        active: "Активні",
        inactive: "Неактивні",
        pending: "Очікування",
        apply: "Застосувати",
        setting: "Налаштування",
        edited: "змінено",
        editAsJson: "Редагувати як JSON",
        editAsTable: "Редагувати як таблицю",
        image: "Зображення",
        file: "Файл",
        send: "Надіслати",
        close: "Закрити",
        reject: "Відхилити",
        confirm: "Підтвердити",
        setOn: "Встановлено",
        logout: "Вийти",
        wrongPasswordOrLoginOrLicenseMessage: "Помилка авторизації. Перевірте логін та пароль.",
        id: "ІД",
        operator: "Оператор",
        channelType: "Тип каналу",
        channelName: "Назва каналу",
        chatTag: "Тег",
        phrase: "Фраза",
        data: "Дані",
        fileSendLikeImageError: "Цей тип зображення можна надіслати лише як файл",
        changesNotBeApplied: "Внесені зміни не буде застосовано до змінених налаштувань",
        supervisor: "Супервізор",
        admin: "Адмін",
        bot: "Бот",
        offlineStatusConfirmation: "При переході в офлайн усі чати будуть зняті та розподілені в чергу. Продовжити?",
        chatType: "Тип чату",
        operatorType: "Тип оператора",
        messengerExternalId: "Зовнішній ід засоби зв'язку",
        ascending: "За зростанням",
        descending: "За спаданням",
        ai: "ШІ",
        attachment: "Вкладення",
        stop: "Зупинити",
        location: "Геолокація",
        audio: "Аудіо",
        video: "Відео",
        device: "Пристрій",
        browser: "Браузер",
    },
    analytics: {
        statistics: "Статистика",
        monitoring: "Моніторинг",
        reports: "Звіти",
        exportReport: "Експорт",
        comeFrom: "Попередній крок",
        dialog: "Діалог",
        wentTo: "Наступний крок",
        getSettingForChartsMessage: "Не вдалося завантажити налаштування для діаграм.",
        reportOutOfRangeException: "Неможливо сформувати звіт через обмеження формату файлу.",
        reportException: "Сталася помилка під час вивантаження звіту."
    },
    channels: {
        operatorsForChannel: "Оператори для каналу",
        operator: "Оператор",
        feedback: "Відгук",
        vip: "ВІП",
        spam: "Спам",
        comments: "Коментарі",
        emptyNameTooltipErrorMessage: "Назва не може бути порожньою",
        emptyTokenTooltipErrorMessage: "Токен не може бути порожнім",
        channelCreatingErrorMessage: "Будь ласка, збережіть або видаліть новий канал",
        createChannel: "Створити канал",
        sureDeleteChannel: "Ви дійсно хочете видалити канал?",
        saveChannelSuccessMessage: "Успішно збережено",
        saveNewChannelSuccessMessage: "Канал успішно створено",
        saveChannelErrorMessage: "Помилка збереження каналу",
        saveNewChannelErrorMessage: "Не вдалося зберегти новий канал",
        channelAlreadyExists: "Канал з таким токеном вже існує",
        uniformWidgetStartSignalRError: "Сталася помилка підключення до конектора {{url}}",
        deleteChannelSuccessMessage: "Успішно видалено",
        deleteNewChannelSuccessMessage: "Канал не збережено",
        deleteChannelErrorMessage: "Помилка видалення каналу",
        copyScriptHeader: "Скрипт скопійовано",
        copyScriptBody: "Скрипт скопійовано в буфер обміну. Використовуйте Ctrl+V для вставлення на сайт.",
        telegram: "Телеграм",
        viber: "Вайбер",
        viberAlfa: "Вайбер альфа",
        vk: "ВК",
        widget: "Віджет",
        facebook: "Фейсбук",
        weChat: "ВіЧат",
        instagram: "Інстаграм",
        uniformWidget: "Віджет Уніформи",
        ednaWhatsApp: "Вотсап (Edna)",
        whatsApp: "Вотсап",
        voiceChannel: "Голосовий канал",
        telegramPrivate: "Телеграм (Особистий)",
        restartChannelSuccessMesage: "Канал успішно перезапущено",
        restartChannelQuestion: "Ви впевнені, що хочете перезапустити канал?",
        restartOnlyEnabledChannel: "Канал має бути увімкненим",
        askYouWannaDeleteChannel: "{0} користувач(ів) використовують цей канал. Можливість спілкування з ними буде втрачена. Все одно видалити?",
        channelNotExists: "Канал з ІД {{channelId}} не існує",
        sendPulse: "SendPulse",
        sms: "Sms",
        importOperators: "Перемістити менеджерів",
        currentChannel: "в канал",
        selectSourceChannel: "Виберіть канал-джерело",
        keepOperatorsInSourceChannel: "Зберегти менеджерів в каналі-источнике",
        operatorsImported: "Менеджери успішно переміщені."
    },
    chat: {
        transfer: "Передати",
        comment: "Коментар",
        transferToOperator: "Передати оператору",
        transferToBot: "Передати боту",
        transferToGroup: "Передати групі",
        invite: "Запросити",
        editMessage: "Редагувати повідомлення",
        doLeaveChat: "Ви хочете покинути чат?",
        doExportChat: "Ви хочете експортувати чат?",
        exportSuccess: "Чат успішно експортовано",
        exportError: "Експорт до зовнішньої CRM не налаштовано",
        externalCrmOptionsAreNotConfidured: "Налаштування зовнішньої CRM не вказані",
        export: "Експортувати",
        pause: "Пауза",
        unpause: "Зняти паузу",
        setPauseHeader: "Виберіть категорію паузи",
        removePauseHeader: "Зняти паузу",
        removePause: "Зняти паузу",
        resendMessage: "Повторно надіслати",
        setPause: "Поставити на паузу",
        pauseWithoutNotifacation: "Пауза без повідомлення клієнта",
        pauseWithNotifacation: "Пауза з повідомленням клієнта",
        pauseBotChatError: "Неможливо поставити чат з ботом на паузу",
        leave: "Покинути",
        sendingFiles: "Надсилання {{sendingFilesCount}} файлів...",
        join: "Приєднатися",
        close: "Закрити",
        closeChat: "Закрити чат",
        save: "Зберегти",
        fillInfo: "Заповніть інформацію",
        category: 'Категорія',
        subject: 'Тематика',
        categoryAndSubjectSavedError: 'Для закриття чату заповніть всі поля',
        categoryAndSubjectSavedSuccessfully: 'Категорія та тематика успішно збережені',
        messageDeleted: "Повідомлення видалено",
        messageFileNoEdit: "Повідомлення з файлом/зображенням не можна редагувати.",
        messageFileNoDelete: "Повідомлення з файлом/зображенням не можна видалити.",
        cannotSaveEmptyMessaage: "Неможливо зберегти порожнє повідомлення, використовуйте кнопку видалення",
        cannotEditMessageWrongChannelType: "Неможливо відредагувати повідомлення. Неправильний тип каналу.",
        sendFileMessageError: "Сталася помилка під час надсилання файлу",
        continue: "Продовжити",
        tagSaveError: "Для збереження тегів заповніть обидва поля",
        tagSaveSuccess: "Теги успішно збережені",
        markAsSpam: "Позначити як спам",
        contactHasOpenedChatException: "З цим контактом є відкритий чат. ChatId - {0} Operator - {1}",
        enabledChannelNotFoundException: "Неможливо розпочати новий чат - немає увімкнених каналів",
        searchByMessenger: "Завантажити історію з месенджера",
        cannotCloseChatNoAccesRights: "Неможливо закрити чат - недостатньо прав",
        cannotReopenChatNoAccesRights: "Не вдалося відкрити чат повторно через відсутність прав доступу",
        createNewChatError: "Немає запущеного каналу для створення чату через месенджер",
        initConversationError: "Сталася помилка під час надсилання шаблонного повідомлення.",
        businessInitiatedTemplateNotFound: "Неможливо розпочати новий чат - в каналі немає шаблону стартового повідомлення.",
        chatTypePrivate: 'Особисті повідомлення',
        chatTypeGroup: 'Група',
        chatTypeComment: 'Коментарі',
        chatTypeMailing: 'Розсилка',
        summary: 'Резюме',
        summaryCompleted: 'Завершено',
        summaryFailed: 'Помилка',
        summaryInProgress: 'Обробляється',
        nluSearchTooltip: 'Пошук в NLU...',
        deleted: 'видалено',
        cannotEditDeleteMessage: "Не вдається відредагувати повідомлення. Це повідомлення було видалено.",
        chatClosedWaitingClientResponse: "Чат із клієнтом створено за шаблоном та закрито в очікуванні відповіді клієнта.", 
        selectTemplate: "Виберіть шаблон для відправки",
        show: "Показати",
        hide: "Приховати",
        edited: "змінено",
        closeDialogWithoutSaving: "У вас є незбережені зміни. Ви впевнені, що хочете закрити?",
        messageSendError: "Сталася помилка при відправці повідомлення (зверніться до адміністратора).",
        closeChatTitle: "Виберіть спосіб закриття чату",
        closeNormally: "Закрити чат с повідомленням",
        closeSilently: "Закрити чат без повідомлень",
        resetRecordingConfirmation: "Ви впевнені, що хочете перезаписати наявний запис? Поточний запис буде видалено.",
        recordingNotSent: "Ваш запис не було надіслано. Закрити вікно й видалити його?",
        edit: "Редагувати",
        reply: "Відповісти",
        quote: "Цитувати",
        deletedMessage: "Видалене повідомлення"
    },
    chats: {
        my: "Мої",
        withMe: "Зі мною",
        all: "Всі",
        archive: "Архів",
        autoUpdateChat: "Автооновлення",
        info: "Інформація",
        statistics: "Статистика",
        closed: "Закрито",
        pause: "ПАУЗА",
        active: "Активний",
        expired: "Прострочено",
        finished: "Завершено",
        missed: "Пропущено",
        chatNumber: "Номер чату",
        askYouWannaCloseChat: "Ви хочете закрити чат?",
        askYouWannaJoinChat: "Ви хочете приєднатися до чату?",
        askYouWannaReopenChat: "Ви хочете поновити чат?",
        operatorNotAssignedYetMessage: "Ще не призначено",
        openChatErrorMessage: "Щось пішло не так під час відкриття чату.",
        continueChatErrorMessage: "Не можу розпочати чат. Переконайтеся, що канал існує та запущений.",
        editMessageSuccessMessage: "Успішно відредаговано",
        deleteMessageSuccessMessage: "Успішно видалено",
        deleteMessageError: "Сталася помилка при видаленні",
        editMessageErrorMessage: "Сталася помилка під час редагування.",
        chatAlreadyClosing: "Закриття чату вже обробляється",
        chatClosedSuccessfully: "Чат успішно закрито",
        chatClosedErrorMessage: "Сталася помилка під час закриття чату",
        enterChatName: "Введіть назву чату...",
        messageFromMyself: "Ви",
        messageFromClient: "Клієнт",
        messageFromOperator: "Оператор",
        messageFromSystem: "Система",
        messageFromBot: "Бот",
        attachmentMessage: "*вкладення*",
    },
    contact: {
        sureDeleteAccount: "Ви дійсно хочете видалити акаунт?",
        createNewAccounts: "Створити новий акаунт",
        noRecords: "Записів немає",
        phoneNumber: "Номер телефону",
        firstName: "Ім'я",
        lastName: "Прізвище",
        middleName: "По-батькові",
        name: "Ім'я",
        chatName: "Назва чату",
        comment: "Коментар",
        chatsCount: "Кількість чатів",
        externalId: "Зовнішній ІД",
        locale: "Мова",
        noContacts: "Контактів немає",
        createContact: "Створити контакт",
        saveContactSuccessMessage: "Успішно збережено",
        saveNewContactSuccessMessage: "Контакт успішно створено",
        saveContactErrorMessage: "Помилка збереження контакту",
        saveNewContactErrorMessage: "Не вдалося зберегти новий контакт",
        deleteContactSuccessMessage: "Успішно видалено",
        deleteNewContactSuccessMessage: "Успішно видалено",
        deleteContactErrorMessage: "Помилка видалення контакту",
        deleteMessenger: "Ви дійсно хочете видалити месенджер?",
        cantDeletePrimaryContactMessenger: "Неможливо видалити основний месенджер контакту",
        createMessenger: "Створити засіб зв'язку",
        channelName: "Назва каналу",
        messengerNickname: "Нікнейм",
        messengerToken: "Номер",
        contactFoundMessage: "Контакт знайдено",
        contactNotFoundMessage: "Контакт не знайдено",
        contactReceivingByIdNotFoundMessage: "Контакт c id рівним {{contactId}} не знайдено",
        chooseFile: "Виберіть файл",
        errorSavingAccountWithoutData: "Неможливо зберегти акаунт з порожніми полями",
        errorSavingAccountOnlyWithSpaces: "Неможливо зберегти акаунт з полями, що містять лише пробіли",
        errorSavingAccountCharactersEqualOrMore50: "Неможливо зберегти акаунт, де кількість символів у полі перевищує 50",
        errorSavingAccountIdWithSpaces: "Неможливо зберегти акаунт, де поле ІД містить пробіли",
        newDialogueWithClient: "Ви хочете розпочати новий діалог з клієнтом?",
        fillAtLeastOneAnthroponym: "Введіть хоча б одне ім'я: ім'я, прізвище або по-батькові",
        unsupportedAvatarImageType: "Непідтримуваний тип зображення",
        firstMessengerDevice: "Інформація про перший пристрій",
    },
    license: {
        botUsage: "Боти",
        operatorUsage: "Оператори",
        nlpUsage: "Запити до NLU",
        mailingUsage: "Розсилки",
        currentUsage: "Зараз використано",
        avalableUsage: "Усього доступно",
        leftUsage: "Залишилось",
        licenseExpiresAt: "Ліцензія закінчується {{date}}",
        licenseDaysLeft: "Залишилось {{days}} днів",
        confirmPasswordNotMatchMessage: "Паролі не збігаються!",
        unknownErrorMessage: "Сталася помилка під час активації доступу, зверніться до адміністратора!",
        licenseErrorMessage: "Помилка ліцензії, зверніться до адміністратора!",
        licenseExpiredErrorMessage: "Термін ліцензії закінчився, зверніться до адміністратора!",
        licenseAlreadyActivatedMessage: "Ця ліцензія вже активована.",
        userAlreadyExistMessage: "Користувач з таким логіном вже існує.",
        loginFormatErrorMessage: "Логін може містити лише латинські літери, знак \"_\" та цифри",
        updateLicenseSuccessMessage: "Ліцензія успішно оновлена!",
        updateLicenseErrorMessage: "Помилка оновлення ліцензії!",
        licenseExpiresPart: 'У вас залишилося {{days}} днів ліцензії, зверніться до адміністратора!',
        mailingExpires: 'Ви використали {{mailingUsed}} розсилок. Всього доступно {{totalMailings}} розсилок',
        nlpExpires: 'Ви використали NLU пошук {{nlpUsed}} разів. Всього доступно {{totalNlps}}',
        license: "Ліцензія",
        licenseDetails: "Деталі ліцензії",
        title: "Активація доступу",
        loginLabel: "Логін адміністратора",
        loginPlaceholder: "Логін",
        passwordLabel: "Пароль адміністратора",
        passwordPlaceholder: "Пароль",
        confirmPasswordLabel: "Повторіть пароль",
        confirmPasswordPlaceholder: "Повторіть пароль",
        licenseTitle: "Ліцензія",
        submitButton: "Активувати доступ",
        notEnoughSlotsError: "Недостатньо слотів. Зверніться до адміністратора з питань ліцензування",
        enabledOperatorsMoreThanSpecifiedInLic: "Кількість активних операторів перевищує ліцензійну. Ви можете вимикати операторів у розділі Оператори",
        enabledBotsMoreThanSpecifiedInLic: "Кількість активних ботів перевищує ліцензійну. Ви можете вимикати ботів у розділі Оператори",
        customerIdChanged: "Ідентифікатор клієнта ліцензії не може бути змінено.",
    },
    mailing: {
        bot: "Бот",
        mailingResult: "Результат розсилки",
        additionalData: "Додаткові параметри",
        message: "Повідомлення",
        linkText: "Текст посилання",
        linkUrl: "Посилання",
        image: "Зображення",
        isEmergency: "Дозволити відправку в активний чат",
        disableLinkTracking: "Не відстежувати переходи за посиланнями",
        sendingType: "Тип надсилання",
        sendToAllMessengers: "Надіслати у всі месенджери",
        sendToLastMessenger: "Надіслати в останній месенджер",
        sendCascade: "Каскадна розсилка",
        uploadImage: "Завантажити",
        createMailing: "Створити розсилку",
        pending: "Очікування..",
        inProgress: "В процесі",
        finished: "Завершено",
        stopped: "Зупинено",
        canceled: "Скасовано",
        canNotSaveEmptyMessageError: "Неможливо зберегти порожнє повідомлення.",
        canNotSendCascadeMailingWithoutSelectedChannels: "Для каскадної розсилки оберіть канали.",
        canNotSaveEmptyNameError: "Неможливо зберегти з порожньою назвою.",
        canNotSaveWrongLinkUrlError: "Неможливо зберегти. Неправильна адреса посилання",
        canSaveLinkWithoutLinkTextError: "Неможливо зберегти. Текст посилання не заповнено",
        canNotSaveWithoutBotError: "Неможливо зберегти. Бот не вибрано",
        saveMailingSuccess: "Розсилку успішно збережено.",
        saveMailingError: "Сталася помилка під час збереження.",
        startMailingStartMessage: "Розсилка розпочата.",
        deleteMailingSuccessMessage: "Успішно видалено",
        deleteMailingErrorMessage: "Помилка видалення розсилки.",
        sendMessageFailed: "Сталася помилка під час надсилання повідомлення. Деталі в логах",
        noFilterChoosenMessage: "Фільтр контактів/чатів не обрано, розсилка буде для всіх контактів",
        contactsWithTemplates: "Контакти із шаблонами",
        templateVariables: "Змінні шаблон",
        mailingReceivingByIdNotFoundMessage: "Розсилку з id рівним {{ mailingId }} не знайдено",
        fileMayNotBeDelivered: "Через розмір файл може бути доставлений не в усі месенджери.",
        mailingResultsReceivingByIdNotFoundMessage: "Результат розсилки з id рівним {{mailingId}} не знайдено",
        stopMailingMessage: "Розсилка була зупинена.",
        sureDeleteMailing: "Ви дійсно хочете видалити розсилку?",
        noRecipients: "Отримувачів немає",
    },
    nlp: {
        foundViaML: "Ця відповідь знайдена за допомогою ІІ.",
        question: "Запитання",
        answer: 'Відповідь',
        createNewTopic: "Створити нову бібліотеку",
        createNewPair: "Створити нову пару",
        doWantDeleteTopic: "Ви дійсно хочете видалити бібліотеку?",
        doWantDeleteTopicPair: "Ви дійсно хочете видалити пару?",
        doWantUndoTopicPairChanges: "Ви хочете скасувати зміни пар?",
        selectPair: "Обрати пару",
        applySelected: "Застосувати вибране",
        deleteSelected: "Видалити вибране",
        transferQuestion: "Перемістити запитання",
        move: "Перемістити",
        to: "до",
        askYourQuestion: "Задайте ваше запитання",
        unsupportedMessageType: "Непідтримуваний тип повідомлень",
        answerNotFound: "Відповідь не знайдено",
        actualSearchString: "Фактичний рядок пошуку:",
        sureRemoveButton: "Ви дійсно хочете видалити кнопку ",
        buttonType: "Тип кнопки",
        text: "Текст",
        value: "Значення",
        noFoundTopicPair: "Пари тем не знайдено.",
        buttonTextExists: "Кнопка з таким текстом вже існує.",
        newButton: "Нова кнопка",
        buttonEditing: "Редагування кнопки",
        saveTopicSuccessMessage: "Успішно збережено",
        saveTopicErrorMessage: "Помилка збереження теми",
        deleteTopicSuccessMessage: "Успішно видалено",
        deleteTopicErrorMessage: "Помилка видалення теми",
        exportPairsErrorMessage: "Помилка експорту пар",
        importPairsErrorMessage: "Помилка імпорту пар",
        importPairsSuccessMessage: "Пари успішно імпортовано",
        publishQuestionsSuccessMessage: "Успішно опубліковано",
        publishQuestionsMLSuccessMessage: "Успішно опубліковано (Режим машинного навчання)",
        publishQuestionsErrorMessage: "Помилка публікації",
        publishQuestionsMLErrorMessage: "Помилка публікації (Режим машинного навчання)",
        saveTopicPairSuccessMessage: "Успішно збережено",
        saveTopicPairErrorMessage: "Помилка збереження",
        synonyms: "Синоніми",
        synonyms_placeholder: "привіт : здрастуйте|салют|хай|здоров\nдобре : відмінно|гуд|круто\nчистий : свіжий|охайний|митий",
        synonyms_fill: 'Введіть синоніми. Кожне слово з нового рядка, потім двокрапка та синоніми через "|"',
        synonyms_needColon: "Відсутня двокрапка між словом та синонімами в рядку \n",
        synonyms_fewColons: "Більше однієї двокрапки (:) в рядку ",
        synonyms_wrongCharacter: "Недопустимий символ в рядку \n",
        synonyms_needWord: "Відсутнє слово в рядку \n",
        synonyms_needSynonyms: "Відсутні синоніми в рядку \n",
        synonyms_emptySynonym: "Порожній синонім в рядку \n",
        synonym_stopWord: "Помилка. \"{{sw}}\" є стоп-словом",
        deleteTopicPairSuccessMessage: "Успішно видалено",
        deleteTopicPairErrorMessage: "Помилка видалення",
        changeTopicPairStatusSuccessMessage: "Успішно змінено",
        changeTopicPairStatusErrorMessage: "Помилка зміни статусу пар(и) тем",
        transferQuestionToTopicPairSuccessMessage: "Успішно переміщено",
        transferQuestionToTopicPairErrorMessage: "Помилка переміщення запитання в пару тем",
        theme: "Тема",
        triggerName: "Назва тригера",
        trigger: "Тригер",
        subject: "Тематика",
        source: "Джерело",
        topicPairContentType_text: "Текст",
        topicPairContentType_markup: "Маркування",
        topicPairContentType_video: "Відео",
        topicPairContentType_audio: "Аудіо",
        topicPairContentType_navigation: "Перенаправлення",
        topicPairContentType_textToSpeech: "Автовідтворення",
        topicPairContentType_iframe: "Фрейм",
        nlpButtonType_trigger: "Тригер",
        nlpButtonType_text: "Текст",
        nlpButtonType_link: "Посилання",
        nlpButtonType_customEvent: "Спеціальна Подія",
        nlpButtonType_back: "Назад",
        nlpButtonType_requestContact: "Запит Контакту",
        nlpButtonType_requestGeolocation: "Запит Геолокації",
        nlpButtonEdit: "редагувати",
        nlpButtonDelete: "видалити",
        errorSendNLPSearchWhenOperatorOffline: "Перейдіть в онлайн або паузу, щоб надіслати повідомлення",
        messageDontHaveAccessToTopic: "Вибачте, у вас немає доступу до цієї теми",
        questionWithOnlyStopWordsError: "Запитання <{{question}}> складається зі стоп-слів",
        changeVersionConfirm: "Непубліковані зміни буде втрачено, продовжити?",
        designerViewButton: "Дизайнер",
        listViewButton: "Список",
        designerAlignNodesButton: "Вирівняти",
        designerTakeScreenshotButton: "Експорт в файл",
        aiSearchWithNullConfidenceError: "Сталася помилка під час пошуку вектора. Можливо, забули опублікувати топік?",
        noOptionsText: "Відповідних варіантів не знайдено",
        exceededLimitButton: "Перевищено ліміт 20 символів, кнопка може не надійти в деякі месенджери.",
        autocompleteOpenText: "Відкрити",
        autocompleteCloseText: "Закрити",
        autocompleteClearText: "Очистити",
        emptyNlpTooltipMessage: "Назва бібліотеки не може бути порожньою",
        topicReceivingByIdNotFoundMessage: "Бібліотеку c id рівним {{topicId}} не знайдено",
        noAvailablePairsForTransfer: "Немає доступних пар для перенесення",
        emptyButtonNameTooltipMessage: "Кнопка не може бути збережена, текст порожній",
        buttonRow: "Рядок",
        addButtonRow: "Додати рядок",
    },
    operators: {
        name: "Ім'я",
        displayName: "Відображуване ім'я",
        createOperator: "Створити оператора",
        sureRemoveOperator: "Ви дійсно хочете видалити оператора?",
        emptyNameTooltipMessage: "Ім'я не може бути порожнім",
        emptyLoginTooltipMessage: "Логін не може бути порожнім",
        emptyPasswordTooltipMessage: "Пароль не може бути порожнім",
        minLengthPasswordMessage: "Пароль має бути довшим за ",
        maxLengthPasswordMessage: "Пароль має бути коротшим за ",
        minLengthLoginMessage: "Логін має бути довшим за ",
        maxLengthLoginMessage: "Логін має бути коротшим за ",
        changeAvatarNullIdErrorMessage: "Неможливо змінити аватар нествореного оператора",
        saveOperatorSettingsNullIdMessage: "Неможливо зберегти налаштування нествореного оператора",
        spaceInLoginErrorMessage: "Логін не може містити пробіли",
        operatorCreatingErrorMessage: "Неможливо створити кілька операторів одночасно!",
        uploadScript: "Завантажити",
        saveOperatorNoChangesMessage: "Оператор не змінився",
        saveOperatorSuccessMessage: "Успішно збережено",
        duplicatedOperatorNameErrorMessage: "Оператор з таким ім'ям вже існує",
        duplicatedOperatorLoginErrorMessage: "Оператор з таким логіном вже існує",
        incorrectFileFormatErrorMessage: "Невірний формат файлу. Будь ласка, завантажте .zip архів",
        deleteOperatorSuccessMessage: "Успішно видалено",
        cannotDeleteYourself: "Неможливо видалити поточного оператора",
        deleteOperatorErrorMessage: "Помилка видалення оператора",
        incorrectLoginMessage: "Логін містить недопустимі символи",
        fileNotChoosen: "Файл не обрано",
        removeOperator: "Видалити оператора",
        logoutOperatorByOperator: "Адміністратор {0} відключив вас з системи",
        logoutOperator: "Адміністратор відключив вас з системи",
        setAvatarError: "Сталася помилка під час встановлення аватара",
        setAvatarSuccess: "Аватар успішно оновлено",
        downloadBotScriptError: "Сталася помилка під час вивантаження скрипта бота",
        operatorTypeOperator: "Оператор",
        operatorTypeBot: "Бот",
        operatorTypeSupervisor: "Супервізор",
        operatorTypeHuman: "Людина",
        operatorTypeQueue: "Черга"
    },
    settings: {
        createSettings: "Створити налаштування",
        settingIdCannotBeEmpty: "Неможливо зберегти налаштування з порожнім ідентифікатором.",
        confirmDeleteSetting: "Видалити налаштування",
        settingIdAlreadyExists: "Налаштування з ідентифікатором {id} вже існує.",
        settingId: "Назва",
        emptySettingTooltipMessage: "Назва не може бути порожньою",
        key: "Ключ",
        value: "Значення",
        system: "Система",
        integration: "Інтеграція",
        settingSaved: "Налаштування успішно збережено",
        settingDeleted: "Налаштування видалено"
    },
    chatsPanel: {
        youAreLoggedInAs: "Ви увійшли як ",
        toChangeTheUserPress: "Щоб змінити користувача, натисніть ",
        haveBeenAssignedChannels: "Вам призначені канали: ",
        errorReopenChatDueOfflineStatus: "Перейдіть в онлайн або паузу, щоб продовжити чат",
        cannotOpenChatInWidgetChannel: "Не вдається відкрити чат у каналі віджета.",
        sendMessageError: "Сталася помилка під час надсилання повідомлення",
        sendFileMessageError: "Сталася помилка під час надсилання файлу",
    },
    permission: {
        editPermissionsFor: "Змінити дозволи для ",
        tabRole: "Ролі",
        tabUsers: "Користувачі",
        selectUser: "Виберіть користувача",
        Audit_Manage: "Керування аудитом",
        Contacts_Manage: "Керування контактами",
        Chats_ManageOwnChats: "Керування власними чатами",
        Chats_TransferChats: "Перевод чатів",
        Mailing_Manage: "Керування розсилками",
        Chats_ManageOthersChats: "Керування чужими чатами",
        NLP_Search: "Пошук у базі NLU",
        NLP_Manage: "Керування базою NLU",
        Operators_Manage: "Керування списком операторів та призначення каналів операторам",
        Channels_Manage: "Керування каналами",
        Integrations_Manage: "Керування налаштуваннями інтеграцій",
        CanManageAnalytics: "Робота з аналітикою",
        License_Manage: "Керування ліцензією",
        savePermissionsSuccessMessage: "Дозволи успішно збережено",
        Chats_SendFiles: "Надсилання файлів",
        Permission_Manage: "Управління дозволами",
        Chats_CloseSilently: "Закриття чатів без повідомлень",
        confirmRestorePermissions: "Ви впевнені, що хочете скинути права користувача?",
        restorePermissionsSuccessMessage: "Права користувача успішно скинуті",
    },
    logging: {
        title: "Логування",
        service: "Сервіс",
        validate: "Перевірити",
        apply: "Застосувати",
        reset: "Повернути з appsettings",
        hint: "Секція «NLog» сервісу. Діє на всіх клієнтів одразу після застосування і зберігається в nlog.override.json поруч з appsettings.json, тому переживає перезапуск. «Повернути з appsettings» видаляє цей файл. Помилки в ${…} перевірка не знаходить.",
        overrideActive: "Зараз діє nlog.override.json: конфігурацію з appsettings перевизначено. Зміни NLog в appsettings (зокрема після оновлення) не застосовуються, доки не натиснути «Повернути з appsettings».",
        valid: "Конфігурація коректна",
        applied: "Конфігурацію застосовано",
        resetDone: "Відновлено конфігурацію з appsettings",
        customerExample: "Приклад: Debug лише для одного клієнта (додати в «rules»)"
    },
    error: {
        nlpTopicAlreadyExistsError: "Бібліотека з ім'ям {{topicName}} вже існує.",
        disableWithOpenChats: "Не вдалося оновити канал з ідентифікатором {{channelId}}: неможливо вимкнути канал, якщо відкриті чати",
        changeTokenWhenOpenChats: "Не вдалося оновити канал з ідентифікатором {{channelId}}: неможливо змінити тип або токен, якщо на каналі є чати.",
        connectionError: "Помилка з'єднання. Спробуйте пізніше.",
        invalidDateMessage: "Неправильний формат дати",
        leftDateLessMessage: "Дата зліва менша за дату справа",
        error: "Помилка!",
        channelNotInitialized: "Канал не ініціалізовано",
        nlpTopicNotFoundError: "Топік {{topicName}} не знайдено",
        invalidTokenErrorMessage: "Будь ласка, авторизуйтесь, щоб продовжити",
        loginFailed: "Помилка авторизації. Перевірте логін та пароль",
        botBlockedByUser: "Користувач заблокував канал!",
        moreThanOneFile: "Ви можете перетягнути лише 1 файл",
        incorrectFileType: "Ви можете перетягувати лише файли",
        FailedLicenseValidation: "Помилка ліцензії, зверніться до адміністратора!",
        LicenseExpired: "Термін ліцензії закінчився, зверніться до адміністратора!",
        LicenseAlreadyActivated: "Ця ліцензія вже активована.",
        UserAlreadyExist: "Користувач з таким логіном вже існує.",
        sendFileNotSupported: "Цей канал не підтримує надсилання файлів",
        typeOfSendedFileNotSupported: "Цей канал не підтримує надсилання цього типу файлів",
        saveImageBase64: "Неможливо зберегти зображення з Base64",
        cannotSendMessageNotChatParticipant: "Неможливо надіслати повідомлення, оскільки оператор не є учасником чату",
        sendMessageFailed: "Надіслати повідомлення не вдалося. ChatId: {{chatId, number}} OperatorId: {{operatorId, number}}",
        duplicatedData: "Дублювання даних для {{constraintName}}",
        messengerNotFound: "Не вдається знайти доступні месенджери",
        chatNotFound: "Чат {{chatId}} не знайдено",
        fileMaxSize: "Максимальний розмір файлу не повинен перевищувати {{maxSize}}MB",
        fileSizeExceeded: "Не вдалося відправити файл. Його розмір ({{currentSizeMb}} МБ) перевищує максимально допустимий ліміт у {{maxSizeMb}} МБ",
        fileDownloadError: "Помилка завантаження файлу",
        grafanaCreateScope: "Не вдалося створити контекст для графани",
        grafanaLogin: "Не вдалося отримати cookie для графіків",
        scriptFileNotFound: "Файл скрипта бота не знайдено",
        invalidOperatorModel: "Дані оператора недійсні для збереження",
        fileTooLargeErrorMessage: "Розмір файлу занадто великий",
        chatAlreadyClose: "Чат {{chatId, number}} вже закрито.",
        parentCommentDeleted: "Батьківський коментар видалено автором. Відповідь не може бути надіслано.",
        messageSentOutsideOfAllowedWindow: "Повідомлення не може бути надіслано в Facebook чат пізніше ніж через 24 години після повідомлення користувача.",
        messageSentOutsideOf48HourAllowedWindow: "Повідомлення не може бути надіслано у цей чат більш ніж через 48 годин після повідомлення користувача.",
        messageLengthExceeded: "Перевищено допустиму кількість символів. Максимальна довжина повідомлення: {{symbolsCount}} символів.",
        instagramUserDisabledMentions: "Упоминаемый користувач відключив можливість його згадувати в налаштуваннях. Удалите згадування і спробуйте ще раз.",
        fetchFailedQr: "Не вдалося отримати QR-код",
        messageModificationOutsideOfAllowedWindow: "Повідомлення не можна модифікувати, минуло занадто багато часу з моменту відправлення.",
        saveTelegramPrivateMessengerError: "Не вдалося зберегти месенджер для каналу Телеграм (Особистий)",
        channelClientNotInitializedException: "Канал не ініціалізований, спочатку увімкніть канал. Channel id: {{channelId}}",
        chatNotCreated: "Чат не був відкритий. Channel id: {{channelId}}, user id: {{userId}}",
        dailyLimitExceeded: "Перевищено денний ліміт для пользоватя Telegram. Limit: {{limit}}.",
        commentUnavailable: "Не вдається надіслати повідомлення, оскільки коментар недоступний. ChatId: {{chatId}}, MessageId: {{messageId}}",
        microphoneOrCameraPermissonNotGranted: "Щоб ця функція працювала, потрібно надати доступ до мікрофона або камери",
        recordingVideoTooLarge: "Відеозапис завеликий",
        deleteWithOpenChats: "Канал з ІД  {{channelId, number}} не може бути видалений, оскільки в ньому відкриті чати: {{openedChats}}",
    },
    notification: {
        locationText: "Геолокація",
        documentText: "Документ",
        photoText: "Фото",
        newMessageInChat: "Нове повідомлення в чаті ",
        newChatRecieved: "Отримано новий чат!",
        chatId: "ІД чату-",
        connectionError: "Помилка з'єднання!",
        connectionErrorText: "Не вдалося відновити з'єднання, ви будете переведені в статус Офлайн",
        connectionAbortText: "З'єднання було перервано. Оновіть сторінку для відновлення."
    },
    audit: {
        operatorConnectedBySignalR: "Оператор підключився через SignalR",
        operatorDisconnectedBySignalR: "Оператор відключився від SignalR",
        operatorWentOnline: "Оператор вийшов в онлайн",
        operatorWentPause: "Оператор перейшов на паузу",
        operatorWentOffline: "Оператор перейшов в офлайн",
        createSetting: "Оператор створив налаштування",
        updateSetting: "Оператор оновив налаштування",
        removeSetting: "Оператор видалив налаштування",
        createChannel: "Оператор створив канал",
        updateChannel: "Оператор оновив канал",
        removeChannel: "Оператор видалив канал",
        createOperator: "Оператор створив оператора",
        updateOperator: "Оператор оновив оператора",
        removeOperator: "Оператор видалив оператора",
        operatorWentPause1: "Оператор перейшов на паузу1",
        operatorWentPause2: "Оператор перейшов на паузу2",
        operatorWentPause3: "Оператор перейшов на паузу3",
        operatorWentPause4: "Оператор перейшов на паузу4",
        operatorWentPause5: "Оператор перейшов на паузу5",
        operatorWentPause6: "Оператор перейшов на паузу6",
        operatorWentPause7: "Оператор перейшов на паузу7",
        operatorWentPause8: "Оператор перейшов на паузу8",
        operatorWentPause9: "Оператор перейшов на паузу9",
        operatorWentPause10: "Оператор перейшов на паузу10",
    },
    qr: {
        telegram: {
            scanCode: "Відскануйте QR-код. Якщо термін дії QR-коду закінчився, зачекайте або натисніть Оновити.",
            authorized: "Ви ввійшли в систему!",
            initializing: "Ініціалізація...",
            emptySettings: "Відсутні необхідні налаштування: ApiId і ApiHash",
            startChannel: "Канал не запущений.",
            requiresPassword: "Потрібен Хмарний пароль. Оновіть сторінку та перевірте налаштування.",
            requiresManualInput: "Потрібно ручне введення. Оновіть сторінку та перевірте налаштування.",
            loading: "Завантаження...",
            refresh: "Оновити",
            enterByQr: "Вхід по Qr-коду",
        }
    }
};

export default translate;